export const lightspeed = {
  seo: {
    title: 'Lightspeed integratie | Bistroo',
    description: 'Koppel je Lightspeed-kassa aan Bistroo. Online bestellingen komen automatisch als kassatickets binnen, geen handmatig overtypen, geen fouten.',
  },
  hero: {
    category: 'Kassasysteem',
    description: 'Combineer Bistroo\'s moderne besteloplossingen met het toonaangevende kassasysteem van Lightspeed. Een integratie, oneindig gemak voor jouw restaurantactiviteiten.',
    badge: 'Officiële integratiepartner',
    check_1: 'Vrijblijvend en maandelijks opzegbaar',
    check_2: 'Instellen in enkele minuten',
  },
  about: {
    title: 'Wat doet Lightspeed?',
    p1: 'Lightspeed Restaurant is een cloud-kassasysteem dat speciaal is gebouwd voor de horeca. Het biedt real-time inzicht in je omzet, voorraadbeheer en personeelsroosters, allemaal vanuit één dashboard, op elk apparaat. Duizenden horecaondernemers in Nederland en België vertrouwen op Lightspeed.',
    p2: 'Met de Bistroo-koppeling komen online bestellingen van je webshop direct als kassatransacties binnen in Lightspeed. Jouw team hoeft niets over te typen; alles loopt automatisch. Minder fouten, minder stress en een soepelere bediening tijdens de drukste piektijden.',
    benefits_title: 'Wat levert de koppeling op?',
    benefits: [
      'Online orders landen automatisch in je Lightspeed-kassa',
      'Menu-aanpassingen in Bistroo worden gesynchroniseerd',
      'Bezorgtijden en afhaaltijden worden doorgegeven als instructies',
      'Realtime omzetrapportage over alle kanalen gecombineerd',
      'Geen dubbel beheer: één systeem voor kassa én webshop',
    ],
  },
  wordcloud_title: 'Lightspeed in een oogopslag',
  wordcloud: ['Cloud POS', 'Horecakassa', 'Tafelbeheer', 'Voorraadbeheer', 'Kassatickets', 'Realtime rapportage', 'Cloudgebaseerd', 'Orderstromen', 'Automatisering', 'Menukaart', 'API-koppeling', 'Keukenprinten', 'Omzetanalyse', 'Multi-locatie', 'Horecabeheersoftware'],
  usp: {
    heading: 'Alles wat je nodig hebt, perfect geïntegreerd',
    subtitle: 'Krachtige functies die naadloos samenwerken om je restaurantactiviteiten te stroomlijnen',
    items: [
      { icon: 'bi-lightning-charge-fill', title: 'Real-time synchronisatie', text: 'Bestellingen, menu, voorraad en verkoopgegevens direct gesynchroniseerd tussen Bistroo en Lightspeed POS.' },
      { icon: 'bi-bar-chart-fill', title: 'Handmatige tijdsbevestiging', text: 'Uniek aan deze integratie is de mogelijkheid om handmatig een tijd toe te kennen aan afhaal- of bezorgbestellingen.' },
      { icon: 'bi-clock-fill', title: 'Tijdsbesparing & piekbeheer', text: 'Elimineer handmatige gegevensinvoer en loop nooit meer over tijdens piekuren met het slimme tijdslot-algoritme van Bistroo.' },
      { icon: 'bi-people-fill', title: 'Pre-orders, zoals het hoort', text: 'Bestellingen voordat het restaurant geopend is, maar altijd geprint bij opening op de dag van levering.' },
      { icon: 'bi-printer-fill', title: 'Naadloze integratie met de keuken', text: 'Print of toon webshop-bestellingen rechtstreeks via Lightspeed in jouw keuken, precies zoals je gewend bent.' },
      { icon: 'bi-check-circle-fill', title: 'Geen administratieve rompslomp', text: 'De administratie van je online webshop-bestellingen direct in de dagafsluiting via de kassa.' },
    ],
  },
  partnership: {
    title: 'Integratie gebouwd voor groei',
    subtitle: 'Ons partnerschap brengt het beste van twee werelden samen: Bistroo\'s innovatieve besteltechnologie én het toonaangevende kassasysteem van Lightspeed.',
    visual_bistroo: 'Bistroo Webshop',
    visual_bistroo_sub: 'Bestellingen & Beheer',
    visual_lightspeed: 'Lightspeed POS',
    visual_lightspeed_sub: 'Kassasysteem',
    visual_status: 'Verbonden & Gesynchroniseerd',
  },
  setup: {
    heading: 'Zo koppel je Lightspeed aan Bistroo',
    steps: [
      'Log in op je Bistroo Merchant Portal en ga naar Instellingen.',
      'Open het tabblad Integraties en klik op Lightspeed.',
      'Log in met je Lightspeed-account en autoriseer de koppeling via OAuth.',
      'Koppel je menucategorieën aan de juiste Lightspeed-afdelingen.',
      'Verwerk een testbestelling, het ticket verschijnt direct in je kassa.',
    ],
  },
  faq: {
    items: [
      { q: 'Welke versie van Lightspeed heb ik nodig?', a: 'De Bistroo-koppeling werkt met Lightspeed Restaurant (K-Series). Zorg dat je abonnement de API-toegang inbegrepen heeft; dit is het geval bij de meeste betaalde Lightspeed-plannen.' },
      { q: 'Worden menu-aanpassingen automatisch gesynchroniseerd?', a: 'Ja. Wanneer je een product toevoegt of aanpast in Bistroo, wordt dit automatisch doorgegeven aan Lightspeed. Andersom kun je wijzigingen ook vanuit Lightspeed importeren in Bistroo.' },
      { q: 'Kan ik meerdere verkooppunten koppelen?', a: 'Zeker. Als je meerdere vestigingen hebt, kun je per locatie een aparte Bistroo-webshop koppelen aan het betreffende Lightspeed-verkooppunt.' },
      { q: 'Wat gebeurt er als de internetverbinding wegvalt?', a: 'Bistroo slaat bestellingen op in de cloud. Zodra de verbinding is hersteld, worden openstaande orders automatisch doorgestuurd naar Lightspeed.' },
      { q: 'Is de Lightspeed-koppeling inbegrepen bij mijn Bistroo-abonnement?', a: 'Ja, de koppeling is onderdeel van je standaard Bistroo-abonnement. Er zijn geen extra installatiekosten.' },
    ],
  },
  cta: {
    title: 'Klaar om het te proberen?',
    subtitle: 'Start vandaag en ervaar hoe Bistroo en Lightspeed samenwerken voor jouw restaurant. Geen installatiekosten, maandelijks opzegbaar.',
    button_primary: 'Gratis starten',
    button_secondary: 'Plan een demo',
    footer_text: 'Instellen in minder dan 10 minuten · Maandelijks opzegbaar',
  },
}
